module.exports = __webpack_public_path__ + "img/HK.5ba5f8cf.png";